import { render } from "./ChevronDownIcon.vue?vue&type=template&id=52dd9bf6"
import script from "./ChevronDownIcon.vue?vue&type=script&lang=js"
export * from "./ChevronDownIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__